import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/eagletrace_logo.png'
import _imports_1 from '../assets/insights.png'
import _imports_2 from '../assets/transactions.png'
import _imports_3 from '../assets/customers.png'
import _imports_4 from '../assets/intelligence.png'
import _imports_5 from '../assets/datasets.png'
import _imports_6 from '../assets/settings.png'
import _imports_7 from '../assets/users.png'


const _withScopeId = n => (_pushScopeId("data-v-b665ae3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-layout" }
const _hoisted_3 = { class: "sidebar-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"200px"},
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_5 = { class: "sidebar-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_1,
  alt: "insights"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_2,
  alt: "transactions"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_3,
  alt: "customers"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_4,
  alt: "intelligence"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_5,
  alt: "datasets"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_6,
  alt: "settings"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"35px"},
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "sidebar-footer" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_17 = { class: "profile-description" }
const _hoisted_18 = { style: {"margin-bottom":"10px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_logout_button = _resolveComponent("logout-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/dashboard" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _hoisted_6,
              _createVNode(_component_router_link, { to: "/dashboard" }, {
                default: _withCtx(() => [
                  _createTextVNode("Insights")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _hoisted_7,
              _createVNode(_component_router_link, { to: "/dashboard/transactions" }, {
                default: _withCtx(() => [
                  _createTextVNode("Transactions")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _hoisted_8,
              _createVNode(_component_router_link, { to: "/dashboard/customers" }, {
                default: _withCtx(() => [
                  _createTextVNode("Customers")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _hoisted_9,
              _createVNode(_component_router_link, { to: "/dashboard/intelligence" }, {
                default: _withCtx(() => [
                  _createTextVNode("Intelligence")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createVNode(_component_router_link, { to: "/dashboard/datasets" }, {
                default: _withCtx(() => [
                  _createTextVNode("Datasets")
                ]),
                _: 1
              })
            ]),
            _hoisted_11,
            _createElementVNode("li", null, [
              _hoisted_12,
              _createVNode(_component_router_link, { to: "/dashboard/settings" }, {
                default: _withCtx(() => [
                  _createTextVNode("Settings")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _hoisted_13,
              _createVNode(_component_router_link, { to: "/dashboard/users" }, {
                default: _withCtx(() => [
                  _createTextVNode("Users")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString($setup.user?.name), 1),
            _createElementVNode("div", null, _toDisplayString($setup.user?.email), 1),
            _createVNode(_component_logout_button)
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}